import React from 'react';
import classnames from 'classnames';

import { DiffHeaderInfoFragment } from '../../graphql/__generated__/graphql';
import DiffHeaderInfo from './DiffHeaderInfo';
import DiffHeaderNav from './DiffHeaderNav';

export type DiffHeaderProps = {
  className?: string;
  diffIds: string[];
  diff: DiffHeaderInfoFragment | undefined | null;
  prevPage: () => void;
  nextPage: () => void;
  stepId: string;
}

export const DiffHeader: React.FC<DiffHeaderProps> = (
  {
    className,
    diff,
    prevPage,
    nextPage,
    stepId,
    diffIds,
  },
) => (
  <div
    className={classnames(
      className,
      'flex bg-white border-0 border-b border-solid border-gray-200 z-20 relative min-h-9',
    )}
  >
    <div className="-mt-px px-2 flex flex-grow items-center justify-between w-full">
      <div className="relative min-w-8 flex-1">
        <DiffHeaderInfo
          diff={diff}
        />
      </div>
      <DiffHeaderNav
        diffIds={diffIds}
        nextPage={nextPage}
        prevPage={prevPage}
        stepId={stepId}
      />
    </div>
  </div>
);
export default DiffHeader;
